// import React from 'react'

// Components
import { Rectangle } from '../../components/Rectangle/Rectangle'
import { AnimatedScreenWrapper } from '../../components/AnimatedScreenWrapper/AnimatedScreenWrapper'

// Svg
import { AppStore, AngleRight } from '../../assets'
import { Button } from '../../components/Button/Button'

// Styles
import './done.scss'

export interface DoneScreenProps {}

export const DoneScreen = (props: DoneScreenProps) => {
  const {} = props

  const onHandleGoAppStore = () => {}

  return (
    <div className="full-screen done-bg">
      <AnimatedScreenWrapper>
        <div className="grid">
          <div>
            <AppStore />
          </div>
          <Rectangle>
            <h5 className="main-title">Welcome to the community!</h5>
            <p className="description-thin">
              To continue the process and connect your Inspiration Display please download the Presence app now.
            </p>
            <Button onClick={onHandleGoAppStore}>
              Go to app store <AngleRight />
            </Button>
          </Rectangle>
        </div>
      </AnimatedScreenWrapper>
    </div>
  )
}
